import instoreAdOffers from './InstoreAdOffers';

export default instoreAdOffers;
